import { Component, ChangeDetectionStrategy, input, output, computed } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'nx-simple-paginator',
  templateUrl: './simple-paginator.component.html',
  styleUrls: ['./simple-paginator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SimplePaginatorComponent {
  // Inputs
  readonly currentPage = input.required<number>(); // 0-based
  readonly pageSize = input.required<number>();
  readonly totalElements = input.required<number>();
  readonly pageSizeOptions = input<number[]>([20, 50, 100]);
  
  // Outputs
  readonly pageChange = output<number>(); // emits new page number (0-based)
  readonly pageSizeChange = output<number>(); // emits new page size
  
  // Computed
  readonly pageSizeSelectOptions = computed(() => 
    this.pageSizeOptions().map(size => ({
      id: size.toString(),
      name: `${size} anzeigen`
    }))
  );
  
  readonly hasPrevious = computed(() => this.currentPage() > 0);
  readonly hasNext = computed(() => {
    const currentPage = this.currentPage();
    const pageSize = this.pageSize();
    const totalElements = this.totalElements();
    const totalPages = Math.ceil(totalElements / pageSize);
    return currentPage < totalPages - 1;
  });
  
  onPrevious(): void {
    if (this.hasPrevious()) {
      this.pageChange.emit(this.currentPage() - 1);
    }
  }
  
  onNext(): void {
    if (this.hasNext()) {
      this.pageChange.emit(this.currentPage() + 1);
    }
  }
  
  onPageSizeChange(newSizeId: string): void {
    const newPageSize = parseInt(newSizeId, 10);
    this.pageSizeChange.emit(newPageSize);
  }
}
